const initialState = {

   
    loading: false,
    shows: []
}

const shows = (state = initialState , action) => {

    switch(action.type) {
        case 'FETCH_SHOW':
           //return state.posts =  action.payload
          return {...state,...{loading: true },...action.payload}
      
         case 'UPDATE_SHOW':
            //return {...state,...{loading: true },...action.payload}
            return {...state,...{loading: true },...action.payload}
            
        default:
            return state
    }
}

export default shows